
import { useState } from 'react';

export default function QuestionsToAsk() {
  const [expandedCategory, setExpandedCategory] = useState<number | null>(0);

  const categories = [
    {
      title: 'Coverage & Scope',
      icon: 'ri-shield-check-line',
      color: 'from-[#e10708] to-[#c00607]',
      questions: [
        'Does the policy cover ransomware payments, and are there limits or conditions?',
        'Is social engineering fraud (wire transfers, invoice fraud, impersonation) covered?',
        'Are regulatory fines, legal defense costs, and breach notification expenses included?',
        'Does coverage extend to cloud services and third-party providers?'
      ]
    },
    {
      title: 'Claims & Response',
      icon: 'ri-alarm-warning-line',
      color: 'from-[#c00607] to-[#a00506]',
      questions: [
        'What is the process and timeline for reporting a suspected incident?',
        'Are there approved vendors (forensics, legal, PR) we must use?',
        'Is there a 24/7 incident response hotline?'
      ]
    },
    {
      title: 'Pre-Breach & Preventive Services',
      icon: 'ri-shield-star-line',
      color: 'from-[#a00506] to-[#e10708]',
      questions: [
        'What pre-breach services are included (risk assessments, phishing training, vulnerability scans)?',
        'Are discounts available for implementing specific security controls?',
        'Will the insurer reassess coverage as our security posture improves?'
      ]
    },
    {
      title: 'Policy Management',
      icon: 'ri-file-list-3-line',
      color: 'from-[#e10708] to-[#c00607]',
      questions: [
        'How often must we re-attest to security controls?',
        'What changes to our environment require notification?',
        'How does non-compliance with stated controls affect a future claim?'
      ]
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-orange-600 to-red-600 rounded-full mb-6">
            <i className="ri-question-line text-3xl text-white"></i>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Questions You Should Ask the Insurer
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-4">
            Cyber insurance policies vary widely. Ask these questions before binding coverage:
          </p>
          <div className="inline-flex items-center gap-2 bg-orange-50 px-4 py-2 rounded-lg border border-orange-200">
            <i className="ri-lightbulb-line text-orange-600"></i>
            <span className="text-orange-800 font-semibold">This Is Often Overlooked</span>
          </div>
        </div>

        <div className="space-y-4">
          {categories.map((category, index) => (
            <div 
              key={index}
              className="bg-white border-2 border-gray-200 rounded-xl overflow-hidden hover:border-red-300 transition-all"
            >
              <button
                onClick={() => setExpandedCategory(expandedCategory === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between cursor-pointer hover:bg-gray-50 transition-all whitespace-nowrap"
              >
                <div className="flex items-center gap-6">
                  <div className={`flex-shrink-0 w-14 h-14 bg-gradient-to-br ${category.color} rounded-lg flex items-center justify-center`}>
                    <i className={`${category.icon} text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">
                    {category.title}
                  </h3>
                </div>
                <i className={`ri-arrow-${expandedCategory === index ? 'up' : 'down'}-s-line text-2xl text-gray-400`}></i>
              </button>

              {expandedCategory === index && (
                <div className="px-8 pb-8 pt-4 bg-gradient-to-br from-gray-50 to-white border-t border-gray-200">
                  <ul className="space-y-4">
                    {category.questions.map((question, qIndex) => (
                      <li key={qIndex} className="flex items-start gap-4">
                        <i className="ri-question-mark text-[#e10708] text-xl flex-shrink-0 mt-1"></i>
                        <span className="text-gray-800 leading-relaxed font-medium">{question}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}